<template>
  <div>
    <vxe-grid
      ref="skuTable"
      size="mini"
      cell-class-name="align-top"
      resizable
      auto-resize
      show-footer
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :footer-method="() => footerData"
      :edit-config="{ trigger: 'manual', mode: 'row', enabled: !disabled }"
      :edit-rules="editRules"
      @edit-actived="editActived"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="left"
          >
            <i class="el-icon-edit tool-btn" @click="edit(row)" />
          </el-tooltip>
          <br />
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="left"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)" />
          </el-tooltip>
        </div>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:60px;height:60px;"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width:60px;height:60px;"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div v-if="row.goodsSize">
            <span class="mr-1">SIZE:</span>
            <span>{{ row.goodsSize }}</span>
          </div>
          <div v-if="row.goodsColor || row.goodsColorEn">
            <span class="mr-1">COLOR:</span>
            <span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <div>
            <span class="mr-1">NC:</span>
            <span>{{ row.ncNo }}</span>
          </div>
          <div>
            <span class="mr-1">SKU:</span>
            <span>{{ row.hxSkuNo }}</span>
          </div>
          <div v-if="row.eanCode">
            <span class="mr-1">UPC:</span>
            <span>{{ row.eanCode }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayPlatform="{ row }">
        <div class="m-0">
          <span>{{ row.salesTitle }}</span>
        </div>
        <span> {{ '渠道Item号' }}： </span>
        <span style="color: #409EFF">{{ row.channelItemNo }}</span>
        <br />
        <span>{{ '渠道条码号' }}：</span>
        <span style="color: #409EFF">{{ row.channelEanNo }}</span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import {
  format,
  add,
  multiply,
  divide,
  divideRound,
} from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      tableColumns: tableColumns(this),
      currActivedRow: {},
      editRules: {
        inCtnQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        purchaseQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
          {
            validator: ({ row }) => {
              const { inCtnQty, purchaseQty } = row
              const ctnQty = divideRound(purchaseQty, inCtnQty, 0)
              const submitQty = multiply(inCtnQty, ctnQty)
              if (submitQty !== purchaseQty) {
                return new Error('采购数量不满整箱')
              }
            },
          },
        ],
        purchasePrice: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          const val = totalColumnValues[t.field]
          return val ? format(val) : '0'
        })
      result[2] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    editActived({ row }) {
      this.currActivedRow = { ...row }
    },
    async editClosed({ row }) {
      const res = await this.$api
        .ecomHxPreOrderDetailUpdateApi({ ...row })
        .catch(() => null)
      const { status } = res || {}
      if (status !== 200) {
        row.inCtnQty = this.currActivedRow.inCtnQty
        row.purchaseQty = this.currActivedRow.purchaseQty
        row.ftyMoq = this.currActivedRow.ftyMoq
        row.ftyLeadTime = this.currActivedRow.ftyLeadTime
        row.expectDeliveryDate = this.currActivedRow.expectDeliveryDate
        row.avgSevenDayQty = this.currActivedRow.avgSevenDayQty
        row.lessThanMoq = this.currActivedRow.lessThanMoq
        row.remark = this.currActivedRow.remark
        setTimeout(() => {
          this.$refs.skuTable.updateFooter()
        }, 0)
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      const { purchasePrice, purchaseQty, inCtnQty } = row
      row.subAmount = multiply(purchasePrice, purchaseQty)
      row.ctnQty = divide(purchaseQty, inCtnQty)

      this.$emit('edit-reload')
      setTimeout(() => {
        this.$refs.skuTable.updateFooter()
      }, 0)
    },
    async edit(row) {
      this.$refs.skuTable.setActiveRow(row)
    },
    async del({ hxPreOrderDetailCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxPreOrderDetailDelApi({ hxPreOrderDetailCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.$emit('edit-reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
